import React, { Component } from "react";
import { connect } from "react-redux";
import { removeMovieFavorite } from "../../actions";
import { Link } from 'react-router-dom';
import './Favorites.css';

export class ConnectedList extends Component {

  render() {
    return (
      <div className="favs-container">
        <h2>Películas Favoritas</h2>
        <ul>
          {/* Aqui deberias poner tu lista de peliculas! */}
          {
            this.props.movies?.map(m => (
              <div key={m.imdbID}>
                <Link to={`/movie/${m.imdbID}`}>
                  <li>{m.Title}</li>
                  <img src={`${m.Poster}`} alt="Poster"></img>
                  <li>{m.Poster}</li>
                </Link>
                <button
                  className="boton"
                  onClick={() => this.props.removeMovieFavorite(m.imdbID)}>
                  <div>
                    <span>Eliminar</span>
                  </div>
                </button>
              </div>
            ))
          }
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    movies: state.moviesFavourites,
  };
}


export default connect(mapStateToProps, { removeMovieFavorite })(ConnectedList);
